import { buildSonarqubeConfig } from '../../deployment/sonarqubeConfig';
import React, { useEffect, useState } from "react";
import { useParams } from 'react-router-dom';
import TextField from "@material-ui/core/TextField";
import { CustomHeaderWithOutAppBar } from "../../components/header/index.jsx";
import './integrationagent.scss';
import { Container, Col, Row, Button, Tabs, Tab } from 'react-bootstrap';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { useNavigate } from 'react-router-dom';
import url, { backendUrl } from "../../config.js"
import socketIOClient from "socket.io-client";
import ConsolePromptPanel from '../../components/consolePromptPanel/index.jsx';
import ConfluenceSection from "../../components/confluence/index.jsx";



import { get } from "http";
import { platform } from "os";

const domain = url.domain;
const socketUrl = url.SOCKET;

function AIChat() {
  let { projId, projName } = useParams();

  const [socket, setSocket] = useState(null);
  const [sessionId, setSessionId] = useState(null);
  const [showExamples, setShowExamples] = useState(false);
  const [logsVisible, setLogsVisible] = useState(true);
  // const [projName, setProjectName] = useState('');
  // const [projId, setProjId] = useState('');
  const [selectedCloudHubAccount, setSelectedCloudHubAccount] = useState('');
  const [selectedRepoType, setSelectedRepoType] = useState('');
  const [selectedRepoAccount, setSelectedRepoAccount] = useState('');
  const [selectedDevOpsType, setSelectedDevOpsType] = useState('');
  const [selectedDevOpsAccount, setSelectedDevOpsAccount] = useState('');
  const [selectedSonarqubeAccount, setSelectedSonarqubeAccount] = useState('');
  const [deploymentLogs, setDeploymentLogs] = useState([]);
  const [isDeploying, setIsDeploying] = useState(false);
  const [selectedEnvironment, setSelectedEnvironment] = useState('');
  const [selectedEnvironmentId, setSelectedEnvironmentId] = useState('');
  const [environments, setEnvironments] = useState([]);
  const [loadingEnvironments, setLoadingEnvironments] = useState(false);
  const [environmentError, setEnvironmentError] = useState(null);
  const [confluenceAccounts, setConfluenceAccounts] = useState([]);
  const [selectedConfluenceAccount, setSelectedConfluenceAccount] = useState(null);
  const [confluenceCreationResult, setConfluenceCreationResult] = useState(null);
  const [confluenceCreationError, setConfluenceCreationError] = useState(null);
  const [isCreatingConfluencePage, setIsCreatingConfluencePage] = useState(false);
  const [selectedDevOpsConfig, setSelectedDevOpsConfig] = useState({
    organization: '',
    organizationName: '', // Extracted clean name
    pat: '',
    // For other platforms if needed later
    repository: '',
    project: '',
    server: ''
  });
  const [selectedRepoConfig, setSelectedRepoConfig] = useState({
    username: '',
    token: '',
    email: '',
    workspace: '' // For Bitbucket
  });

  const [selectedMuleConfig, setSelectedMuleConfig] = useState({
    connAppClientId: '',
    connAppClientSecret: '',
    muleClientId: '',
    muleClientSecret: '',
    muleOrgId: ''
  });


  const navigate = useNavigate();

  const [state, setState] = useState({
    chat: '',
    chatResponse: '',
    page: 'chatdashboard',
    code: '',
    getresponse: false, // Start with false - will be set to true after generation
    activeCode: 'chatdashboard',
    loading: false,
    progress: { step: '', percent: 0 },
    activeTab: 'visualization',
    showHistory: false,
    xmlData: '',
    ramlData: '',
    dependencyData: '',
    plantUML: '',
    projectPath: '',

    // Add these to your state initialization:
    applicationData: '',
    controllerData: '',
    dockerfileData: '',
    k8sDeploymentData: '',
    k8sServiceData: '',
    projectName: '',
    packageName: '',
    activeSpringTab: 'application',
    activeDeployTab: 'dockerfile',
    // ADD THESE 4 NEW FIELDS:
    selectedCloudProvider: 'aws',
    selectedCloudAccount: '',
    awsDeploymentTarget: 'eks',     // 'eks', 'ecs', 'ec2', etc.
    azureDeploymentTarget: '',
    awsaccount: [],
    selectedCloudAccount: '',
    awsSecretAccessKey: '',
    awsAccessKeyId: '',
  });

  const fetchEnvironments = async (accountId) => {
    if (!accountId) {
      setEnvironments([]);
      return;
    }

    setLoadingEnvironments(true);
    setEnvironmentError(null);
    setEnvironments([]);
    setSelectedEnvironment('');

    try {
      // Get the selected account's credentials
      const selectedMuleAccount = state.mule?.find(acc => acc._id === accountId);

      if (!selectedMuleAccount) {
        setEnvironmentError('Account not found');
        setLoadingEnvironments(false);
        return;
      }

      // Prepare credentials to send to backend
      const credentials = {
        connAppClientId: selectedMuleAccount.connAppClientId || '',
        connAppClientSecret: selectedMuleAccount.connAppClientSecret || '',
        muleClientId: selectedMuleAccount.muleClientId || '',
        muleClientSecret: selectedMuleAccount.muleClientSecret || '',
        muleOrgId: selectedMuleAccount.muleOrgId || ''
      };

      console.log("🔄 Fetching environments for account:", selectedMuleAccount.muleOrg);
      console.log("📍 URL:", domain + '/api/v1/mule/org/environments');

      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': localStorage.getItem('token')
        },
        body: JSON.stringify(credentials)
      };

      const response = await fetch(domain + '/api/v1/mule/org/environments', requestOptions);

      const result = await response.json();

      if (response.ok && result.success) {
        // ✅ Extract the 'data' array from the response
        const envList = result.data || [];
        setEnvironments(envList);
        console.log('✅ Environments loaded:', envList.length);
        console.log('📋 Environments:', envList);
      } else {
        setEnvironmentError(result.error || result.message || 'Failed to load environments');
        console.error('❌ Failed to load environments:', result);
      }
    } catch (error) {
      console.error('❌ Error fetching environments:', error);
      setEnvironmentError('Failed to connect to server');
    } finally {
      setLoadingEnvironments(false);
    }
  };

  // Add near the top with other handler functions
  const handleAccountSelect = (account) => {
    setSelectedConfluenceAccount(account);
    setConfluenceCreationResult(null);
    setConfluenceCreationError(null);
  };

  const handleConfluenceSubmit = async (spaceKey, pageNameValue) => {
    console.log("CONFLUENCE SUBMIT", spaceKey, pageNameValue);

    if (!selectedConfluenceAccount || !spaceKey.trim() || !pageNameValue.trim()) {
      alert('Please select an account, space, and enter a page name');
      return;
    }

    setIsCreatingConfluencePage(true);
    setConfluenceCreationResult(null);
    setConfluenceCreationError(null);

    await handleAddToConfluence(selectedConfluenceAccount, spaceKey, pageNameValue);

    // Reset form
    setSelectedConfluenceAccount(null);
  };

  const handleAddToConfluence = async (account, spaceKey, pageNameValue) => {
    console.log("ADDING TO CONFLUENCE", spaceKey, pageNameValue);

    if (!account) return;

    try {
      // Build content based on selected technology
      let contentPayload = {
        description: `Generated ${state.selectedTech === 'mule' ? 'MuleSoft Integration' : 'Spring Boot Application'}`,
        userRequest: state.chat,
        metadata: {
          technology: state.selectedTech,
          projectName: projName,
          projectId: projId,
          generatedAt: new Date().toISOString()
        }
      };

      // Add technology-specific content
      if (state.selectedTech === 'mule') {
        contentPayload.mulesoft = {
          xmlConfig: state.xmlData,
          ramlSpec: state.ramlData,
          dependencies: state.dependencyData,
          projectPath: state.projectPath
        };
      } else if (state.selectedTech === 'spring') {
        contentPayload.springboot = {
          applicationCode: state.applicationData,
          controllerCode: state.controllerData,
          dependencies: state.dependencyData,
          dockerfile: state.dockerfileData,
          k8sDeployment: state.k8sDeploymentData,
          k8sService: state.k8sServiceData,
          projectPath: state.projectPath,
          projectName: state.projectName,
          packageName: state.packageName
        };
      }

      const response = await fetch(`${backendUrl}/api/v1/llm-mcp-connector`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': localStorage.getItem('token')
        },
        body: JSON.stringify({
          title: pageNameValue || projName,
          spaceKey: spaceKey,
          baseUrl: account.confluenceBaseUrl,
          email: account.confluenceEmail,
          apiToken: account.confluencePat,
          type: 'integration', // Changed from 'design' to 'integration'
          content: state.documentationData
        }),
      });

      const result = await response.json();
      console.log('Full response from backend:', result);

      if (result.data?.pageDetails?.url) {
        setConfluenceCreationResult({
          pageUrl: result.data.pageDetails.url,
          pageId: result.data.pageDetails.pageId,
          pageTitle: result.data.pageDetails.title || pageNameValue,
          space: result.data.pageDetails.space || spaceKey,
          message: result.data.message,
          fullMessage: result.data.message
        });

        console.log('✅ Confluence page created:', result.data.pageDetails);
      } else {
        throw new Error(result.error || 'Page creation failed');
      }

    } catch (error) {
      console.error('❌ Error creating Confluence page:', error);
      setConfluenceCreationError(error.message || 'Failed to create Confluence page');
    } finally {
      setIsCreatingConfluencePage(false);
    }
  };

  const handleReset = () => {
    setConfluenceCreationResult(null);
    setConfluenceCreationError(null);
    setSelectedConfluenceAccount(null);
  };

 

  const examplePrompts = [
    {
      id: 1,
      category: 'Mule Salesforce',
      title: 'Salesforce CRUD API with APIKit',
      prompt: 'Create a RESTful API with https listener and apiKit router to create, update, read and delete lead, opportunity objects in Salesforce with mule salesforce connector as a dependency in pom and also provide a proper RAML specification'
    },
    {
      id: 2,
      category: 'Mule Agentforce Odoo',
      title: 'POR Creation in ERP System',
      prompt: 'Create a RESTful API with https listener and apiKit router to create a purchase order in erp system odoo, and the purchase order request contains the name, quantity, cost center, profit center and other required details of a normal purchase order process. This then calls the http rest API exposed by Odoo, assume this has a one to one  mapping with the original request. Add the required dependencies in pom and also provide a proper RAML specification. Follow best practices too.'
    },
    {
      id: 3,
      category: 'Spring boot',
      title: 'Spring boot application ',
      prompt: 'Create an order management system using Spring Boot Rest API having order , payment ,inventory and reporting service with external api integration and h2 database'
    }
  ];

  const recentHistory = [
    { id: 1, title: 'Salesforce Lead Management API', time: '2 hours ago' },
    { id: 2, title: 'MySQL to PostgreSQL Migration Flow', time: '5 hours ago' },
    { id: 3, title: 'SFTP File Processing Integration', time: '1 day ago' }
  ];

  function getResource(item, stateVar) {
    console.log("url", domain + '/api/v1/' + item)
    const requestOptions = {
      method: 'GET',
      headers: { 'x-access-token': localStorage.getItem('token') }
    };
    try {
      fetch(domain + '/api/v1/' + item, requestOptions)
        .then(response => response.json())
        .then(data => {
          console.log("getresource result", item, data);
          if (item.indexOf('mule') !== -1)
            setState(prevState => ({ ...prevState, [stateVar]: data.mule }));
          else if (item.indexOf('jenkins') !== -1)
            setState(prevState => ({ ...prevState, [stateVar]: data.jenkins }));
          else if (item.indexOf('sonarqube') !== -1)
            setState(prevState => ({ ...prevState, [stateVar]: data.sonarqube }));

          else
            setState(prevState => ({ ...prevState, [stateVar]: data }));
        });
    }
    catch (e) {
      console.log("Fetching Error", e)
    }
  }


  // ✅ ADD these new states at the top of your component
  const [integrationLogs, setIntegrationLogs] = useState([]); // NEW: For generation logs
  const [socketConnected, setSocketConnected] = useState(false); // NEW: Track connection status


  useEffect(() => {
    getResource('gitlab', 'gitlab');
    getResource('repo', 'github');
    getResource('azaccount', 'azaccount');
    getResource('awsresource', 'awsresources');
    getResource('awsaccount', 'awsaccount');
    getResource('gkeresource', 'gkeresource');
    getResource('jenkins', 'jenkins');
    getResource('mule', 'mule');
    getResource('confluence', 'confluence');

    var socketUrl = url.SOCKET;

    // Generate session ID FIRST
    const newSessionId = `session-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
    console.log('🆔 Generated Session ID:', newSessionId);
    setSessionId(newSessionId);

    // Create socket
    const socket = socketIOClient(socketUrl, {
      rejectUnauthorized: true,
      transports: ['websocket']   // websocket-only → no sticky sessions needed (K8s multi-pod)
    });



    // ✅ IMPORTANT: Define handlers as named functions for easier cleanup
    const handleConnect = () => {
      console.log('✅ Socket connected:', socket.id);
      console.log('🚪 Joining session room:', newSessionId);
      socket.emit('join-session', newSessionId);
      setSocketConnected(true);

      // setIntegrationLogs(prev => [...prev, {
      //   timestamp: new Date().toISOString(),
      //   level: 'success',
      //   message: `Session established • Ready to build`,
      //   type: 'system'
      // }]);
    };

    const handleJoinedSession = (data) => {
      console.log('✅ Successfully joined session room:', data.sessionId);

      // setDeploymentLogs(prev => [...prev, {
      //   timestamp: new Date().toLocaleTimeString(),
      //   message: '✅ Socket connected and room joined successfully',
      //   type: 'success'
      // }]);

      setIntegrationLogs(prev => [...prev, {
        timestamp: new Date().toISOString(),
        level: 'success',
        // message: '📦 Generated Spring Boot Project Structure:\n' +
        //   '\n' +
        //   '✅ Core Application Files:\n' +
        //   '- pom.xml: Maven configuration with Spring Boot 3.2.5, includes dependencies for spring-boot-starter-web, spring-boot-starter-security (Basic Auth), spring-boot-starter-data-jpa, h2, spring-boot-starter-validation\n' +
        //   '- SpringTestApplication.java: Main Spring Boot application class with @SpringBootApplication\n' +
        //   '- application.properties: Server configuration (port 8080), H2 in-memory database + H2 console, JPA ddl-auto, Basic Auth credentials via properties, external API base URLs\n' +
        //   '\n' +
        //   '✅ Controllers (4 files):\n' +
        //   '- OrderController.java: REST API at /api/orders, 6 endpoints - POST /, GET /{id}, GET /, PUT /{id}/status, POST /{id}/items, POST /{id}/checkout\n' +
        //   '- PaymentController.java: REST API at /api/payments, 3 endpoints - POST /, GET /{id}, GET /order/{orderId}\n' +
        //   '- InventoryController.java: REST API at /api/inventory, 4 endpoints - POST /adjust, GET /{sku}, GET /, POST /reserve\n' +
        //   '- ReportController.java: REST API at /api/reports, 3 endpoints - GET /sales, GET /inventory, GET /orders/status\n' +
        //   '\n' +
        //   '✅ Services (4 files):\n' +
        //   '- OrderService.java: Business logic for order lifecycle, validation, checkout orchestration with inventory reservation + payment initiation; methods: createOrder, getOrder, listOrders, updateStatus, addItems, checkout\n' +
        //   '- PaymentService.java: Business logic for payments, persists Payment, calls external payment API client; methods: createPayment, getPayment, getPaymentsByOrderId\n' +
        //   '- InventoryService.java: Business logic for stock management, reservation, adjustment, calls external inventory API client; methods: adjustStock, getBySku, listInventory, reserveStock\n' +
        //   '- ReportService.java: Reporting queries and aggregation across orders/payments/inventory; methods: salesReport, inventoryReport, orderStatusReport\n' +
        //   '\n' +
        //   '✅ Repositories (4 files):\n' +
        //   '- OrderRepository.java: JPA repository for Order with CRUD and findByStatus\n' +
        //   '- PaymentRepository.java: JPA repository for Payment with CRUD and findByOrderId\n' +
        //   '- InventoryItemRepository.java: JPA repository for InventoryItem with CRUD and findBySku\n' +
        //   '- OrderItemRepository.java: JPA repository for OrderItem with CRUD and findByOrderId\n' +
        //   '\n' +
        //   '✅ Entities (4 files):\n' +
        //   '- Order.java: Database entity with fields: id, customerName, status, totalAmount, createdAt, updatedAt\n' +
        //   '- OrderItem.java: Database entity with fields: id, orderId, sku, quantity, unitPrice, lineTotal\n' +
        //   '- Payment.java: Database entity with fields: id, orderId, amount, method, status, providerRef, createdAt\n' +
        //   '- InventoryItem.java: Database entity with fields: id, sku, name, availableQuantity, reservedQuantity, updatedAt\n' +
        //   '\n' +
        //   '✅ Security:\n' +
        //   '- BasicSecurityConfig.java: Basic authentication (in-memory users) with credentials loaded from application.properties; Swagger/actuator permitted, all other endpoints authenticated\n' +
        //   '\n' +
        //   '✅ External Integrations (2 files):\n' +
        //   '- ExternalPaymentClient.java: External API client for payment authorization/capture simulation (RestTemplate) using configurable base URL\n' +
        //   '- ExternalInventoryClient.java: External API client for inventory reservation/adjustment simulation (RestTemplate) using configurable base URL\n' +
        //   '\n' +
        //   '✅ Tests:\n' +
        //   '- SpringTestApplicationTests.java: Integration test for Spring context (placeholder in typical Spring Initializr setup)\n' +
        //   '\n' +
        //   '📊 Project Stats:\n' +
        //   '- Total Controllers: 4\n' +
        //   '- Total Endpoints: 16\n' +
        //   '- Total Services: 4\n' +
        //   '- Total Entities: 4\n' +
        //   '- Database: H2 (in-memory)\n' +
        //   '- Authentication: Basic\n' +
        //   '- External APIs: 2',
        message: `Connected to integration workspace`,
        type: 'system'
      }]);
    };

    const handleDeploymentLog = (response) => {
      console.log("📝 Deployment log received:", response);

      if (!response || !response.message) {
        console.warn('⚠️ Invalid log format:', response);
        return;
      }

      const timestamp = new Date().toISOString();
      const logEntry = {
        timestamp,
        message: response.message,
        type: response.type || 'info'
      };

      console.log(`[${timestamp}] [${logEntry.type}]`, logEntry.message);
      setDeploymentLogs(prev => [...prev, logEntry]);
    };

    const handleIntegrationLog = (response) => {
      console.log("📝 Integration log received:", response);

      if (!response || !response.message) {
        console.warn('⚠️ Invalid integration log format:', response);
        return;
      }

      const logEntry = {
        timestamp: response.timestamp || new Date().toISOString(),
        level: response.level || 'info',
        message: response.message,
        // ✅ Auto-detect summary type from backend, or check message content as fallback
        type: response.type === 'summary' ? 'summary'
          : response.message.startsWith('📦') ? 'summary'
            : response.type || 'log',
        details: response.details
      };

      console.log(`[${logEntry.timestamp}] [${logEntry.level}]`, logEntry.message);
      setIntegrationLogs(prev => [...prev, logEntry]);
    };
    const handleIntegrationProgress = (progressData) => {
      console.log('📥 Integration progress received:', progressData);

      setState(prev => ({
        ...prev,
        progress: {
          percent: progressData.percentage || prev.progress.percent,
          step: progressData.step || prev.progress.step
        }
      }));
    };

    const handleIntegrationComplete = (resultData) => {
      console.log('📥 Integration complete:', resultData);

      setIntegrationLogs(prev => [...prev, {
        timestamp: new Date().toISOString(),
        level: 'success',
        message: `Integration generated successfully`,
        type: 'system'
      }]);
    };

    const handleDisconnect = (reason) => {
      console.log('❌ Socket disconnected:', reason);
      setSocketConnected(false);

      setIntegrationLogs(prev => [...prev, {
        timestamp: new Date().toISOString(),
        level: 'warning',
        message: `Connection lost • ${reason === 'io server disconnect' ? 'Server closed connection' : 'Reconnecting...'}`,
        type: 'system'
      }]);
    };

    const handleConnectError = (error) => {
      console.error('❌ Socket connection error:', error);

      setIntegrationLogs(prev => [...prev, {
        timestamp: new Date().toISOString(),
        level: 'error',
        message: `Connection failed • ${error.message || 'Unable to reach server'}`,
        type: 'system'
      }]);
    };

    // ✅ ATTACH listeners
    socket.on("connect", handleConnect);
    socket.on('joined-session', handleJoinedSession);
    socket.on('deployment log', handleDeploymentLog);
    socket.on('integration:log', handleIntegrationLog);
    socket.on('integration:progress', handleIntegrationProgress);
    socket.on('integration:complete', handleIntegrationComplete);
    socket.on('disconnect', handleDisconnect);
    socket.on('connect_error', handleConnectError);

    // Handle if already connected
    if (socket.connected) {
      console.log('⚡ Socket already connected, joining room immediately');
      socket.emit('join-session', newSessionId);
    }

    setSocket(socket);

    // ✅ CRITICAL: Cleanup function to remove ALL listeners
    return () => {
      if (socket) {
        console.log('🧹 Cleaning up socket connection');

        // Remove ALL listeners before disconnecting
        socket.off('connect', handleConnect);
        socket.off('joined-session', handleJoinedSession);
        socket.off('deployment log', handleDeploymentLog);
        socket.off('integration:log', handleIntegrationLog);
        socket.off('integration:progress', handleIntegrationProgress);
        socket.off('integration:complete', handleIntegrationComplete);
        socket.off('disconnect', handleDisconnect);
        socket.off('connect_error', handleConnectError);

        // Disconnect socket
        socket.disconnect();
      }
    };
  }, []); // ✅ Empty dependency array - only run once on mount

  function onChange(event) {
    const { value } = event.target;
    setState(prevState => ({ ...prevState, chat: value }));
  }

  const handlePromptClick = (prompt) => {
    setState(prevState => ({ ...prevState, chat: prompt }));
  };



  const handleAccountChange = (type, value) => {
    if (value === 'add_new') {
      navigate('/connected-apps');
      return;
    }

    switch (type) {
      case 'cloudhub':
        setSelectedCloudHubAccount(value);
        const selectedMuleAccount = state.mule?.find(
          acc => acc._id === value
        );
        if (selectedMuleAccount) {
          setSelectedMuleConfig({
            connAppClientId: selectedMuleAccount.connAppClientId || '',
            connAppClientSecret: selectedMuleAccount.connAppClientSecret || '',
            muleClientId: selectedMuleAccount.muleClientId || '',
            muleClientSecret: selectedMuleAccount.muleClientSecret || '',
            muleOrgId: selectedMuleAccount.muleOrgId || ''
          });

          // ✅ Fetch environments after account is selected
          fetchEnvironments(value);
        } else {
          // Clear environments if no account selected
          setEnvironments([]);
          setSelectedEnvironment('');
        }
        break;

      case 'repo-type':
        setSelectedRepoType(value);
        setSelectedRepoAccount('');
        setSelectedRepoConfig({ username: '', token: '', email: '', workspace: '' });
        break;

      case 'repo-account':
        setSelectedRepoAccount(value);
        const selectedRepoAcc = state[selectedRepoType]?.find(
          acc => acc._id === value
        );
        if (selectedRepoAcc) {
          let repoConfig = {
            username: '',
            token: '',
            email: selectedRepoAcc.email || '',
            workspace: ''
          };

          if (selectedRepoType === 'github') {
            repoConfig.username = selectedRepoAcc.gitUsername || '';
            repoConfig.token = selectedRepoAcc.gitPat || '';
          } else if (selectedRepoType === 'gitlab') {
            repoConfig.username = selectedRepoAcc.gitUsername || '';
            repoConfig.token = selectedRepoAcc.gitlabPat || selectedRepoAcc.gitPat || '';
          } else if (selectedRepoType === 'bitbucket') {
            repoConfig.username = selectedRepoAcc.username || '';
            repoConfig.token = selectedRepoAcc.bitbucketToken || selectedRepoAcc.appPassword || '';
            repoConfig.workspace = selectedRepoAcc.workspace || '';
          }

          setSelectedRepoConfig(repoConfig);
          console.log('Repository credentials saved:', {
            platform: selectedRepoType,
            username: repoConfig.username,
            hasToken: !!repoConfig.token
          });
        }
        break;

      case 'devops-type':
        setSelectedDevOpsType(value);
        setSelectedDevOpsAccount('');
        setSelectedDevOpsConfig({
          organization: '',
          organizationName: '',
          pat: '',
          repository: '',
          project: '',
          server: ''
        }); // Reset config
        break;

      case 'devops-account':
        setSelectedDevOpsAccount(value);
        const selectedDevOpsAcc = state[selectedDevOpsType]?.find(
          acc => acc._id === value
        );

        if (selectedDevOpsAcc) {
          let devOpsConfig = {
            organization: '',
            organizationName: '',
            pat: '',
            repository: '',
            project: '',
            server: ''
          };

          // Platform-specific credential extraction
          if (selectedDevOpsType === 'azaccount') {
            devOpsConfig.organization = selectedDevOpsAcc.organization || '';
            devOpsConfig.pat = selectedDevOpsAcc.azDevopsPat || '';

            // Extract clean organization name from URL
            const orgMatch = selectedDevOpsAcc.organization?.match(/dev\.azure\.com\/(.+)/);
            devOpsConfig.organizationName = orgMatch ? orgMatch[1] : selectedDevOpsAcc.organization;

          } else if (selectedDevOpsType === 'github-actions') {
            devOpsConfig.repository = selectedDevOpsAcc.repository || '';
            devOpsConfig.pat = selectedDevOpsAcc.githubToken || '';

          } else if (selectedDevOpsType === 'gitlab-ci') {
            devOpsConfig.project = selectedDevOpsAcc.project || '';
            devOpsConfig.pat = selectedDevOpsAcc.gitlabToken || '';

          } else if (selectedDevOpsType === 'jenkins') {
            devOpsConfig.server = selectedDevOpsAcc.server || '';
            devOpsConfig.pat = selectedDevOpsAcc.jenkinsToken || '';
          }

          setSelectedDevOpsConfig(devOpsConfig);
          console.log('DevOps credentials saved:', {
            platform: selectedDevOpsType,
            organization: devOpsConfig.organization,
            organizationName: devOpsConfig.organizationName,
            hasPat: !!devOpsConfig.pat
          });
        }
        break;

      case 'aws-account':
        if (value === 'add_new') {
          navigate('/connected-apps');
          return;
        }
        const selectedAwsAcc = state.awsaccount?.find(acc => acc._id === value);
        if (selectedAwsAcc) {
          setState(prev => ({
            ...prev,
            selectedCloudAccount: value,
            awsAccessKey: selectedAwsAcc.awsaccesskey || '',
            awsAccessKeyId: selectedAwsAcc.awsaccesskeyid || '',
            awsAccountId: selectedAwsAcc.awsaccountid || ''
          }));
        }
        break;
    }
  };
  const handleSpringBootDeploy = async () => {
    console.log('🚀 Starting Spring Boot deployment process...');

    // Validate all required selections
    if (!selectedRepoAccount || !state.selectedCloudAccount) {
      alert('Please select Repository and Cloud Platform accounts before deploying');
      return;
    }

    // Validate that configs have actual data
    if (!selectedRepoConfig.token || !state.selectedCloudAccount) {
      alert('Missing required credentials. Please ensure all accounts are properly configured.');
      return;
    }

    if (!sessionId) {
      console.error('No session ID available');
      alert('Socket not connected. Please refresh the page.');
      return;
    }

    setDeploymentLogs([]);
    setIsDeploying(true);

    const timestamp = new Date().toISOString();
    setDeploymentLogs([{
      timestamp,
      message: '🚀 Starting Spring Boot deployment process...',
      type: 'info'
    }]);
    console.log('🚀 Starting Spring Boot deployment process...');

    // Build the deployment payload for Spring Boot
    const deploymentPayload = {
      projectPath: state.projectPath || '',
      projectName: projName || state.projectName,
      applicationType: 'springboot',

      // Spring Boot specific configuration
      springboot: {
        projectName: state.projectName,
        packageName: state.packageName
      }
    };

    // Add repository configuration
    if (selectedRepoType === 'github') {
      deploymentPayload.github = {
        enabled: true,
        token: selectedRepoConfig.token,
        owner: selectedRepoConfig.username
      };
    } else if (selectedRepoType === 'gitlab') {
      deploymentPayload.gitlab = {
        enabled: true,
        token: selectedRepoConfig.token,
        owner: selectedRepoConfig.username
      };
    } else if (selectedRepoType === 'bitbucket') {
      deploymentPayload.bitbucket = {
        enabled: true,
        token: selectedRepoConfig.token,
        workspace: selectedRepoConfig.workspace,
        owner: selectedRepoConfig.username
      };
    }

    // Resolve selected cluster early so it's available for all payload blocks
    const selectedCluster = state.awsresources?.find(
      r => r._id === state.awsDeploymentTarget
    );

    // Add DevOps configuration if selected
    if (selectedDevOpsType && selectedDevOpsAccount) {
      if (selectedDevOpsType === 'azaccount') {
        deploymentPayload.azure = {
          enabled: true,
          credentials: {
            pat: selectedDevOpsConfig.pat,
            orgUrl: selectedDevOpsConfig.organization
          },
          "variableGroupName": "build.variables",
          "variables": {
            "awsRegion": selectedCluster?.location || '',
            "awsAccountId": state.awsAccountId || '',
            "eksClusterName": selectedCluster?.awscluster || ''
          },
          "secretVariables": {
            "awsSecretAccessKey": state.awsAccessKey,
            "awsAccessKeyId": state.awsAccessKeyId,
            "awsClusterName": selectedCluster?.awscluster || '',
            "awsRegion": selectedCluster?.location || ''
          },
          "triggerBuild": true
        };
      } else if (selectedDevOpsType === 'github-actions') {
        deploymentPayload.githubActions = {
          enabled: true,
          credentials: {
            token: selectedDevOpsConfig.pat,
            repository: selectedDevOpsConfig.repository
          },
          triggerBuild: true
        };
      } else if (selectedDevOpsType === 'gitlab-ci') {
        deploymentPayload.gitlabCI = {
          enabled: true,
          credentials: {
            token: selectedDevOpsConfig.pat,
            project: selectedDevOpsConfig.project
          },
          triggerBuild: true
        };
      } else if (selectedDevOpsType === 'jenkins') {
        deploymentPayload.jenkins = {
          enabled: true,
          credentials: {
            token: selectedDevOpsConfig.pat,
            server: selectedDevOpsConfig.server
          },
          triggerBuild: true
        };
      }
    }

    // Add cloud platform configuration
    if (state.selectedCloudProvider === 'aws') {
      const selectedAwsAccount = state.awsresources?.find(
        acc => acc._id === state.selectedCloudAccount
      );

      deploymentPayload.aws = {
        enabled: true,
        credentials: {
          accessKeyId: selectedAwsAccount?.accessKeyId || '',
          secretAccessKey: selectedAwsAccount?.secretAccessKey || '',
          region: selectedCluster?.location || selectedAwsAccount?.region || 'us-east-1',
        },
        deploymentTarget: 'eks',
        clusterName: selectedCluster?.awscluster || '',
        environment: 'development'
      };
    } else if (state.selectedCloudProvider === 'azure') {
      const selectedAzureAccount = state.azaccount?.find(
        acc => acc._id === state.selectedCloudAccount
      );

      deploymentPayload.azure = {
        enabled: true,
        credentials: {
          subscriptionId: selectedAzureAccount?.subscriptionId || '',
          tenantId: selectedAzureAccount?.tenantId || '',
          clientId: selectedAzureAccount?.clientId || '',
          clientSecret: selectedAzureAccount?.clientSecret || ''
        },
        "variableGroupName": "build.variables",
        "variables": {
          "awsRegion": selectedCluster?.location || '',
          "awsAccountId": state.awsAccountId || '',
          "eksClusterName": selectedCluster?.awscluster || ''
        },
        "secretVariables": {
          "awsAccessKeyId":state.awsAccessKeyId,
          "awsSecretAccessKey": state.awsSecretAccessKey
        },
        "triggerBuild": true,
        deploymentTarget: state.azureDeploymentTarget || 'aks',
        resourceGroup: 'rg-springboot-dev'
      };
    } else if (state.selectedCloudProvider === 'gcp') {
      const selectedGcpAccount = state.gkeresource?.find(
        acc => acc._id === state.selectedCloudAccount
      );

      deploymentPayload.gcp = {
        enabled: true,
        credentials: {
          projectId: selectedGcpAccount?.projectId || '',
          serviceAccountKey: selectedGcpAccount?.serviceAccountKey || ''
        },
        deploymentTarget: 'gke',
        clusterName: selectedGcpAccount?.clusterName || ''
      };
    }

    console.log('Spring Boot Deployment Payload:', deploymentPayload);

    try {
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': localStorage.getItem('token')
        },
        body: JSON.stringify({
          config: deploymentPayload,
          sessionId: sessionId
        })
      };

      setDeploymentLogs(prev => [...prev, {
        timestamp: new Date().toISOString(),
        message: '📤 Sending deployment request to server...',
        type: 'info'
      }]);

      const response = await fetch(domain + '/api/v1/springboot-deployment', requestOptions);
      const data = await response.json();

      if (data.success) {
        setDeploymentLogs(prev => [...prev, {
          timestamp: new Date().toISOString(),
          message: '✅ Spring Boot deployment initiated successfully!',
          type: 'success'
        }]);

        // Add any logs from backend
        if (data.logs) {
          data.logs.forEach(log => {
            setDeploymentLogs(prev => [...prev, {
              timestamp: new Date().toISOString(),
              message: log.message,
              type: log.type || 'info'
            }]);
          });
        }
      } else {
        setDeploymentLogs(prev => [...prev, {
          timestamp: new Date().toISOString(),
          message: `❌ Deployment failed: ${data.error || 'Unknown error'}`,
          type: 'error'
        }]);
      }

      setIsDeploying(false);

    } catch (error) {
      console.error('Spring Boot deployment error:', error);
      setIsDeploying(false);
      setDeploymentLogs(prev => [...prev, {
        timestamp: new Date().toISOString(),
        message: `❌ Deployment error: ${error.message}`,
        type: 'error'
      }]);
    }
  };
  const submit = () => {

    if (!state.selectedTech) {
      alert('Please select a technology (MuleSoft or Spring Boot) before generating');
      return;
    }
    let url;
    if (state.selectedTech === 'mule') {
      url = domain + '/api/v1/integration'
    } else if (state.selectedTech === 'spring') {
      url = domain + '/api/v1/springboot-integration'
    }
    setIntegrationLogs(prev => [...prev, {
      timestamp: new Date().toISOString(),
      level: 'info',
      message: `🚀 Sending request to server...`,
      type: 'system'
    }]);


    setState(prevState => ({
      ...prevState,
      chatResponse: '',
      loading: true,
      getresponse: false, // Hide results while loading
      progress: { step: 'Analyzing requirements', percent: 25 }
    }));

    setTimeout(() => {
      setState(prev => ({ ...prev, progress: { step: 'Planning flow structure', percent: 50 } }));
    }, 1000);

    setTimeout(() => {
      setState(prev => ({ ...prev, progress: { step: 'Generating Mule code', percent: 75 } }));
    }, 2000);

    var postObj = {
      prompt: state.chat,
      projectName: projName,
      sessionId: sessionId
    };

    console.log("POST OBJ", postObj);

    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'x-access-token': localStorage.getItem('token') },
      body: JSON.stringify(postObj)
    };

    fetch(url, requestOptions)
      .then(response => response.json())
      .then(data => {
        console.log("RESPONSE", data);

        if (data.generated && state.selectedTech === 'mule') {
          setIntegrationLogs(prev => [...prev, {
            timestamp: new Date().toISOString(),
            level: 'info',
            message: `🚀 Integration generated successfully!`,
            type: 'system'
          }]);
          // Convert dependencies array to POM XML format
          const dependenciesXML = data.generated.dependencies
            ? `<dependencies>\n${data.generated.dependencies.map(dep =>
              `    <dependency>
        <groupId>${dep.groupId}</groupId>
        <artifactId>${dep.artifactId}</artifactId>
        <version>${dep.version}</version>
        <classifier>mule-plugin</classifier>
    </dependency>`
            ).join('\n')}\n</dependencies>`
            : '';

          // Update state with generated data
          setState(prevState => ({
            ...prevState,
            documentationData: data.documentation || '',
            xmlData: data.generated.source || '',
            ramlData: data.generated.raml || '',
            dependencyData: dependenciesXML,
            chatResponse: data.generated.analysis || 'Integration generated successfully',
            getresponse: true,
            loading: false,
            projectPath: data.projectPath || '',
            progress: { step: 'Complete', percent: 100 }
          }));

          if (data.summary) {
            setIntegrationLogs(prev => [...prev, {
              timestamp: new Date().toISOString(),
              level: 'info',
              message: data.summary,
              type: 'summary'
            }]);
          }

          // Store in localStorage
          localStorage.setItem('xmlData', data.generated.source || '');
          localStorage.setItem('ramlData', data.generated.raml || '');
          localStorage.setItem('dependencyData', dependenciesXML);
        } else if (data.generated && state.selectedTech === 'spring') {
          setIntegrationLogs(prev => [...prev, {
            timestamp: new Date().toISOString(),
            level: 'info',
            message: `🚀 Integration generated successfully!`,
            type: 'system'
          }]);

          if (data.ast.summary) {
            setIntegrationLogs(prev => [...prev, {
              timestamp: new Date().toISOString(),
              level: 'info',
              message: data.ast.summary,
              type: 'summary'
            }]);
          }
          // Handle Spring Boot integration generation
          setState(prevState => ({
            ...prevState,
            applicationData: data.generated.application || '',
            controllerData: data.generated.controller || '',
            dependencyData: data.generated.dependencies || '',  // ← ADD THIS

            dockerfileData: data.generated.dockerfile || '',
            k8sDeploymentData: data.generated.k8sDeployment || '',
            k8sServiceData: data.generated.k8sService || '',
            chatResponse: data.generated.analysis || 'Integration generated successfully',
            getresponse: true,
            loading: false,
            projectPath: data.projectPath || '',
            progress: { step: 'Complete', percent: 100 }
          }));

          // Store in localStorage
          // localStorage.setItem('applicationData', data.generated.application || '');
          // localStorage.setItem('controllerData', data.generated.controller || '');
          // localStorage.setItem('dockerfileData', data.generated.dockerfile || '');
          // localStorage.setItem('k8sDeploymentData', data.generated.k8sDeployment || '');
          // localStorage.setItem('k8sServiceData', data.generated.k8sService || '');
        } else {
          // Handle error case
          setState(prevState => ({
            ...prevState,
            loading: false,
            chatResponse: 'Failed to generate integration. Please try again.'
          }));
        }
      })
      .catch(error => {
        console.error('Error:', error);
        setState(prevState => ({
          ...prevState,
          loading: false,
          chatResponse: 'An error occurred while generating the integration.'
        }));
      });
  };

  const goBuild = () => {
    localStorage.setItem('message', state.chat);
    navigate(`/projectDetails/${projName}/${projId}`);
  };

  const handleUnifiedDeploy = async () => {
    // Validate all required selections
    if (!selectedCloudHubAccount || !selectedRepoAccount || !selectedDevOpsAccount) {
      alert('Please select CloudHub, Repository, and DevOps accounts before deploying');
      return;
    }

    // Validate that configs have actual data
    if (!selectedMuleConfig.muleOrgId || !selectedRepoConfig.token || !selectedDevOpsConfig.pat) {
      alert('Missing required credentials. Please ensure all accounts are properly configured.');
      return;
    }
    if (!sessionId) {
      console.error('No session ID available');
      alert('Socket not connected. Please refresh the page.');
      return;
    }

    let sonarConfig;
    try { sonarConfig = buildSonarqubeConfig(selectedSonarqubeAccount, state.sonarqube || []); }
    catch (error) { alert(error.message); return; }

    setDeploymentLogs([]);
    setIsDeploying(true);

    const timestamp = new Date().toLocaleTimeString();
    setDeploymentLogs([{
      timestamp,
      message: '🚀 Starting deployment process...',
      type: 'info'
    }]);

    // Build the payload according to your backend structure
    const deploymentPayload = {
      projectPath: state.projectPath || '', // Assuming this contains the full project path
      projectName: projName || state.projectName,
      // Anypoint Platform configuration
      anypoint: {
        enabled: true,
        credentials: {
          clientId: selectedMuleConfig.connAppClientId,
          clientSecret: selectedMuleConfig.connAppClientSecret,
          platformClientId: selectedMuleConfig.muleClientId,
          platformClientSecret: selectedMuleConfig.muleClientSecret,
          orgId: selectedMuleConfig.muleOrgId
        },
        envName: selectedEnvironment,
      },
      sonarqube: sonarConfig
    };

    // Add repository configuration based on selected platform
    if (selectedRepoType === 'github') {
      deploymentPayload.github = {
        enabled: true,
        token: selectedRepoConfig.token,
        owner: selectedRepoConfig.username
      };
    } else if (selectedRepoType === 'gitlab') {
      deploymentPayload.gitlab = {
        enabled: true,
        token: selectedRepoConfig.token,
        owner: selectedRepoConfig.username
      };
    } else if (selectedRepoType === 'bitbucket') {
      deploymentPayload.bitbucket = {
        enabled: true,
        token: selectedRepoConfig.token,
        workspace: selectedRepoConfig.workspace,
        owner: selectedRepoConfig.username
      };
    }

    // Add DevOps configuration based on selected platform
    if (selectedDevOpsType === 'azaccount') {
      deploymentPayload.azure = {
        enabled: true,
        credentials: {
          pat: selectedDevOpsConfig.pat,
          orgUrl: selectedDevOpsConfig.organization
        },
        triggerBuild: true
      };
    } else if (selectedDevOpsType === 'github-actions') {
      deploymentPayload.githubActions = {
        enabled: true,
        credentials: {
          token: selectedDevOpsConfig.pat,
          repository: selectedDevOpsConfig.repository
        },
        triggerBuild: true
      };
    } else if (selectedDevOpsType === 'gitlab-ci') {
      deploymentPayload.gitlabCI = {
        enabled: true,
        credentials: {
          token: selectedDevOpsConfig.pat,
          project: selectedDevOpsConfig.project
        },
        triggerBuild: true
      };
    } else if (selectedDevOpsType === 'jenkins') {
      deploymentPayload.jenkins = {
        enabled: true,
        credentials: {
          token: selectedDevOpsConfig.pat,
          server: selectedDevOpsConfig.server
        },
        triggerBuild: true
      };
    }

    console.log('Deployment Payload:', deploymentPayload);

    try {
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': localStorage.getItem('token')
        },
        body: JSON.stringify({
          config: deploymentPayload,
          sessionId: sessionId
        })
      };

      setDeploymentLogs(prev => [...prev, {
        timestamp: new Date().toISOString(),
        message: '📤 Sending deployment request to server...',
        type: 'info'
      }]);

      const response = await fetch(domain + '/api/v1/deployment', requestOptions);
      const data = await response.json();

      if (data.success) {
        // setDeploymentLogs(prev => [...prev, {
        //   timestamp: new Date().toLocaleTimeString(),
        //   message: '✅ Deployment initiated successfully!',
        //   type: 'success'
        // }]);

        // If there are deployment steps/logs from backend, add them
        if (data.logs) {
          data.logs.forEach(log => {
            setDeploymentLogs(prev => [...prev, {
              timestamp: new Date().toLocaleTimeString(),
              message: log.message,
              type: log.type || 'info'
            }]);
          });
        }
      } else {
        setDeploymentLogs(prev => [...prev, {
          timestamp: new Date().toLocaleTimeString(),
          message: `❌ Deployment failed: ${data.error || 'Unknown error'}`,
          type: 'error'
        }]);
      }

      setIsDeploying(false);

    } catch (error) {
      console.error('Deployment error:', error);
      setIsDeploying(false);
      setDeploymentLogs(prev => [...prev, {
        timestamp: new Date().toLocaleTimeString(),
        message: `❌ Deployment error: ${error.message}`,
        type: 'error'
      }]);
    }
  };
  console.log("STATE", selectedRepoType);


  const getModalBody = () => {
    return (
      <div className="three-column-layout">
        {/* CENTER COLUMN - Preview/Output Area */}
        <div className="center-preview-column">
          {/* Technology Selector */}
          <div className="tech-selector-inline">
            <button
              className={`tech-btn-inline ${state.selectedTech === 'mule' ? 'active' : ''}`}
              onClick={() => setState(prev => ({ ...prev, selectedTech: 'mule' }))}
            >
              ⚡ MuleSoft
            </button>
            <button
              className={`tech-btn-inline ${state.selectedTech === 'spring' ? 'active' : ''}`}
              onClick={() => setState(prev => ({ ...prev, selectedTech: 'spring' }))}
            >
              🍃 Spring Boot
            </button>
            <button className="tech-btn-inline disabled">🟢 Node.js</button>
            <button className="tech-btn-inline disabled">🔷 Golang</button>
          </div>

          {/* Results Display */}
          {state.getresponse ? (
            <div className="preview-content">
              {/* ✅ TABS IN HEADER */}
              <div className="preview-tabs-header">
                <Tabs
                  activeKey={state.activeTab}
                  onSelect={(k) => setState(prev => ({ ...prev, activeTab: k }))}
                  className="preview-nav-tabs"
                >
                  <Tab eventKey="code" title="💻 Code" />

                  {state.selectedTech === 'mule' && (
                    <Tab eventKey="api" title="📄 API" />
                  )}

                  <Tab eventKey="dependencies" title="📦 Dependencies" />

                  {state.selectedTech === 'mule' && (
                    <Tab eventKey="deployment" title="🚀 Deploy" />
                  )}

                  {state.selectedTech === 'spring' && (
                    <Tab eventKey="springDeployment" title="🐳 Deploy" />
                  )}

                  <Tab eventKey="confluence" title="🔗 Confluence" />



                </Tabs>
              </div>

              {/* Tab Content Body */}
              <div className="preview-tab-body">

                {/* ========================================== */}
                {/* CODE TAB */}
                {/* ========================================== */}
                {state.activeTab === 'code' && (
                  <div className="preview-tab-content">
                    {state.selectedTech === 'mule' ? (
                      // MuleSoft Source Code
                      <>
                        <div className="file-header">
                          <span className="file-name">📄 mule-config.xml</span>
                          <button
                            className="copy-btn-small"
                            onClick={() => {
                              navigator.clipboard.writeText(state.xmlData);
                              alert('Copied!');
                            }}
                          >
                            📋
                          </button>
                        </div>
                        <pre className="code-preview">{state.xmlData || 'No code generated'}</pre>
                      </>
                    ) : state.selectedTech === 'spring' ? (
                      // Spring Boot Source Code
                      <>
                        <div className="file-tabs-bar">
                          <button
                            className={`file-tab-btn ${state.activeSpringTab === 'application' ? 'active' : ''}`}
                            onClick={() => setState(prev => ({ ...prev, activeSpringTab: 'application' }))}
                          >
                            Application.java
                          </button>
                          <button
                            className={`file-tab-btn ${state.activeSpringTab === 'controller' ? 'active' : ''}`}
                            onClick={() => setState(prev => ({ ...prev, activeSpringTab: 'controller' }))}
                          >
                            Controller.java
                          </button>
                          <button
                            className="copy-btn-small"
                            onClick={() => {
                              const code = state.activeSpringTab === 'application' ? state.applicationData : state.controllerData;
                              navigator.clipboard.writeText(code);
                              alert('Copied!');
                            }}
                          >
                            📋
                          </button>
                        </div>
                        <pre className="code-preview">
                          {state.activeSpringTab === 'application' ?
                            (state.applicationData || 'No application code') :
                            (state.controllerData || 'No controller code')}
                        </pre>
                      </>
                    ) : null}
                  </div>
                )}

                {/* ========================================== */}
                {/* API TAB - MuleSoft only */}
                {/* ========================================== */}
                {state.activeTab === 'api' && state.selectedTech === 'mule' && (
                  <div className="preview-tab-content">
                    <div className="file-header">
                      <span className="file-name">📄 api.raml</span>
                      <button
                        className="copy-btn-small"
                        onClick={() => {
                          navigator.clipboard.writeText(state.ramlData);
                          alert('Copied!');
                        }}
                      >
                        📋
                      </button>
                    </div>
                    <pre className="code-preview">{state.ramlData || 'No API spec'}</pre>
                  </div>
                )}

                {/* ========================================== */}
                {/* DEPENDENCIES TAB */}
                {/* ========================================== */}
                {state.activeTab === 'dependencies' && (
                  <div className="preview-tab-content">
                    <div className="dependencies-container">
                      <h4 className="section-title">
                        {state.selectedTech === 'spring' ? 'Maven Dependencies' : 'Required Dependencies'}
                      </h4>

                      {state.dependencyData ? (
                        <>
                          {/* Show dependency cards for MuleSoft */}
                          {state.selectedTech === 'mule' && (
                            <div className="dependency-list">
                              {state.dependencyData.split('<dependency>').filter(d => d.trim()).map((dep, idx) => {
                                const artifactMatch = dep.match(/<artifactId>(.*?)<\/artifactId>/);
                                const versionMatch = dep.match(/<version>(.*?)<\/version>/);
                                const groupMatch = dep.match(/<groupId>(.*?)<\/groupId>/);

                                if (artifactMatch) {
                                  return (
                                    <div key={idx} className="dependency-item">
                                      <div className="dep-icon">📦</div>
                                      <div className="dep-info">
                                        <div className="dep-name">{artifactMatch[1]}</div>
                                        {groupMatch && <div className="dep-group">{groupMatch[1]}</div>}
                                        {versionMatch && <div className="dep-version">v{versionMatch[1]}</div>}
                                      </div>
                                    </div>
                                  );
                                }
                                return null;
                              })}
                            </div>
                          )}

                          {/* Show full XML */}
                          <div className="file-header" style={{ marginTop: state.selectedTech === 'mule' ? '20px' : '0' }}>
                            <span className="file-name">
                              {state.selectedTech === 'spring' ? '📄 pom.xml' : '📄 POM Dependencies'}
                            </span>
                            <button
                              className="copy-btn-small"
                              onClick={() => {
                                navigator.clipboard.writeText(state.dependencyData);
                                alert('Copied!');
                              }}
                            >
                              📋
                            </button>
                          </div>
                          <pre className="code-preview">{state.dependencyData}</pre>
                        </>
                      ) : (
                        <div className="placeholder-content">
                          <p>No dependencies available</p>
                        </div>
                      )}
                    </div>
                  </div>
                )}

                {/* ========================================== */}
                {/* CONFLUENCE TAB */}
                {/* ========================================== */}
                {state.activeTab === 'confluence' && (
                  <div className="preview-tab-content">
                    <div className="deployment-config-area">
                      <h4 className="section-title">Publish to Confluence</h4>

                      {!confluenceCreationResult && !confluenceCreationError && (
                        <>
                          {/* Account Selection */}
                          <div className="deployment-section">
                            <h5 className="subsection-title">📝 Select Confluence Account</h5>
                            <div className="confluence-accounts-grid">
                              {state.confluence && state.confluence.length > 0 ? (
                                state.confluence.map((account) => (
                                  <div
                                    key={account._id}
                                    onClick={() => !isCreatingConfluencePage && handleAccountSelect(account)}
                                    className={`confluence-account-card ${selectedConfluenceAccount?._id === account._id ? 'selected' : ''
                                      } ${isCreatingConfluencePage ? 'disabled' : ''}`}
                                  >
                                    <div className="account-icon">
                                      {selectedConfluenceAccount?._id === account._id ? '✓' : '🔗'}
                                    </div>
                                    <div className="account-info">
                                      <div className="account-email">{account.confluenceEmail}</div>
                                      <div className="account-url">{account.confluenceBaseUrl}</div>
                                    </div>
                                  </div>
                                ))
                              ) : (
                                <div className="no-accounts-msg">
                                  <p>No Confluence accounts configured</p>
                                  <button
                                    className="add-account-btn"
                                    onClick={() => navigate('/connected-apps')}
                                  >
                                    + Add Confluence Account
                                  </button>
                                </div>
                              )}
                            </div>
                          </div>

                          {/* ✅ ConfluenceSection Component */}
                          {selectedConfluenceAccount && (
                            <ConfluenceSection
                              selectedAccount={selectedConfluenceAccount}
                              onCreatePage={(data) => {
                                handleConfluenceSubmit(data.spaceKey, data.pageName);
                              }}
                            />
                          )}
                        </>
                      )}

                      {/* Success Result */}
                      {confluenceCreationResult && (
                        <div className="confluence-result success">
                          <div className="result-icon">✅</div>
                          <h3>Page Published Successfully!</h3>
                          <p className="success-msg">
                            {confluenceCreationResult.fullMessage || confluenceCreationResult.message}
                          </p>
                          <div className="page-details">
                            <div className="detail-item">
                              <strong>Title:</strong> {confluenceCreationResult.pageTitle}
                            </div>
                            <div className="detail-item">
                              <strong>Space:</strong> {confluenceCreationResult.space}
                            </div>
                          </div>
                          <div className="result-actions">

                            <a href={confluenceCreationResult.pageUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="open-page-btn"
                            >
                              📄 Open in Confluence ↗
                            </a>
                            <button className="confluence-close" onClick={handleReset}>
                              Close
                            </button>

                          </div>
                        </div>
                      )}

                      {/* Error Result */}
                      {confluenceCreationError && (
                        <div className="confluence-result error">
                          <div className="result-icon">❌</div>
                          <h3>Publication Failed</h3>
                          <p className="error-msg">{confluenceCreationError}</p>
                          <button className="retry-btn" onClick={handleReset}>
                            🔄 Try Again
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                )}

                {/* ========================================== */}
                {/* MULESOFT DEPLOYMENT TAB */}
                {/* ========================================== */}
                {state.activeTab === 'deployment' && state.selectedTech === 'mule' && (
                  <div className="preview-tab-content">
                    <div className="deployment-config-area">
                      <h4 className="section-title">Configure Deployment</h4>

                      {/* Repository Section */}
                      <div className="deployment-section">
                        <h5 className="subsection-title">📦 Repository Configuration</h5>
                        <div className="deployment-row">
                          <div className="deployment-column">
                            <label className="account-label">Select Platform:</label>
                            <select
                              className="account-dropdown"
                              value={selectedRepoType}
                              onChange={(e) => handleAccountChange('repo-type', e.target.value)}
                            >
                              <option value="">-- Select Repository Platform --</option>
                              <option value="github">🐙 GitHub</option>
                              <option value="gitlab">🦊 GitLab</option>
                              <option value="bitbucket">🪣 Bitbucket</option>
                            </select>
                          </div>

                          {selectedRepoType && (
                            <div className="deployment-column">
                              <label className="account-label">Select Account:</label>
                              <select
                                className="account-dropdown"
                                value={selectedRepoAccount}
                                onChange={(e) => handleAccountChange('repo-account', e.target.value)}
                              >
                                <option value="">-- Select {selectedRepoType.charAt(0).toUpperCase() + selectedRepoType.slice(1)} Account --</option>
                                {state[selectedRepoType]?.map((account) => {
                                  let displayName = '';
                                  if (selectedRepoType === 'github') {
                                    displayName = account.gitUsername ? `@${account.gitUsername}` : account.username;
                                  } else if (selectedRepoType === 'bitbucket') {
                                    displayName = account.workspace || account.username;
                                  } else if (selectedRepoType === 'gitlab') {
                                    displayName = account.gitUsername || account.username;
                                  }

                                  return (
                                    <option key={account._id || account.id} value={account._id || account.id}>
                                      {displayName}
                                      {account.email && ` • ${account.email}`}
                                    </option>
                                  );
                                })}
                                <option value="add_new">+ Add New Account</option>
                              </select>
                              {selectedRepoAccount && selectedRepoAccount !== 'add_new' && (
                                <div className="account-selected-badge">✓ Repository Configured</div>
                              )}
                            </div>
                          )}
                        </div>
                      </div>

                      {/* DevOps Section */}
                      <div className="deployment-section">
                        <h5 className="subsection-title">🔧 DevOps Platform</h5>
                        <div className="deployment-row">
                          <div className="deployment-column">
                            <label className="account-label">Select Platform:</label>
                            <select
                              className="account-dropdown"
                              value={selectedDevOpsType}
                              onChange={(e) => handleAccountChange('devops-type', e.target.value)}
                            >
                              <option value="">-- Select DevOps Platform --</option>
                              <option value="azaccount">🔷 Azure DevOps</option>
                              <option value="github-actions">🐙 GitHub Actions</option>
                              <option value="gitlab-ci">🦊 GitLab CI/CD</option>
                              <option value="jenkins">⚙️ Jenkins</option>
                            </select>
                          </div>

                          {selectedDevOpsType && (
                            <div className="deployment-column">
                              <label className="account-label">Select Configuration:</label>
                              <select
                                className="account-dropdown"
                                value={selectedDevOpsAccount}
                                onChange={(e) => handleAccountChange('devops-account', e.target.value)}
                              >
                                <option value="">-- Select Configuration --</option>
                                {state[selectedDevOpsType]?.map((account) => {
                                  let displayName = '';
                                  if (selectedDevOpsType === 'azaccount') {
                                    const orgMatch = account.organization?.match(/dev\.azure\.com\/(.+)/);
                                    displayName = orgMatch ? orgMatch[1] : account.organization;
                                  } else if (selectedDevOpsType === 'github-actions') {
                                    displayName = account.repository || account.name;
                                  } else if (selectedDevOpsType === 'gitlab-ci') {
                                    displayName = account.project || account.name;
                                  } else if (selectedDevOpsType === 'jenkins') {
                                    displayName = account.server || account.name;
                                  }

                                  return (
                                    <option key={account._id} value={account._id}>
                                      {displayName}
                                    </option>
                                  );
                                })}
                                <option value="add_new">+ Add New Configuration</option>
                              </select>
                              {selectedDevOpsAccount && selectedDevOpsAccount !== 'add_new' && (
                                <div className="account-selected-badge">✓ DevOps Configured</div>
                              )}
                            </div>
                          )}
                        </div>
                      </div>

                      {/* CloudHub/Anypoint Section */}
                      <div className="deployment-section">
                        <h5 className="subsection-title">☁️ Anypoint Platform</h5>
                        <div className="deployment-row">
                          <div className="deployment-column">
                            <label className="account-label">Select Account:</label>
                            <select
                              className="account-dropdown"
                              value={selectedCloudHubAccount}
                              onChange={(e) => handleAccountChange('cloudhub', e.target.value)}
                            >
                              <option value="">-- Select Anypoint Account --</option>
                              {state.mule?.map((account) => (
                                <option key={account._id} value={account._id}>
                                  {account.muleOrg}
                                </option>
                              ))}
                              <option value="add_new">+ Add New Account</option>
                            </select>
                            {selectedCloudHubAccount && selectedCloudHubAccount !== 'add_new' && (
                              <div className="account-selected-badge">✓ CloudHub Configured</div>
                            )}
                          </div>

                          {selectedCloudHubAccount && selectedCloudHubAccount !== 'add_new' && (
                            <div className="deployment-column">
                              <label className="account-label">Select Environment:</label>
                              <select
                                className="account-dropdown"
                                value={selectedEnvironment}
                                onChange={(e) => {
                                  const selectedEnvName = e.target.value;
                                  const selectedEnv = environments.find(env => env.name === selectedEnvName);
                                  setSelectedEnvironment(selectedEnvName);
                                  setSelectedEnvironmentId(selectedEnv?.id || '');
                                }}
                                disabled={loadingEnvironments}
                              >
                                <option value="">
                                  {loadingEnvironments
                                    ? '⏳ Loading environments...'
                                    : environments.length === 0 && !environmentError
                                      ? '-- No environments available --'
                                      : '-- Select Environment --'}
                                </option>
                                {environments.map((env) => (
                                  <option key={env.id} value={env.name}>
                                    {env.isProduction ? '🚀' : '🏖️'} {env.name} ({env.type})
                                  </option>
                                ))}
                              </select>

                              {loadingEnvironments && (
                                <div className="loading-indicator">
                                  <span className="spinner"></span> Fetching environments...
                                </div>
                              )}

                              {environmentError && !loadingEnvironments && (
                                <div className="error-message">
                                  ⚠️ {environmentError}
                                  <div className="deployment-column">
                          <label className="account-label" htmlFor="sonarqube-deploy-account">SonarQube configuration (optional):</label>
                          <select id="sonarqube-deploy-account" className="account-dropdown" value={selectedSonarqubeAccount} onChange={event => setSelectedSonarqubeAccount(event.target.value)}>
                            <option value="">Skip SonarQube analysis</option>
                            {(state.sonarqube || []).map(account => <option key={account._id} value={account._id}>{account.sonarServer}</option>)}
                          </select>
                        </div>
                        <button
                                    className="retry-button"
                                    onClick={() => fetchEnvironments(selectedCloudHubAccount)}
                                  >
                                    🔄 Retry
                                  </button>
                                </div>
                              )}

                              {selectedEnvironment && !loadingEnvironments && (
                                <div className="account-selected-badge">
                                  ✓ Environment: {selectedEnvironment}
                                  {environments.find(e => e.name === selectedEnvironment)?.type && (
                                    <span className="env-type-badge">
                                      ({environments.find(e => e.name === selectedEnvironment)?.type})
                                    </span>
                                  )}
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                      </div>

                      {/* Deploy Button */}
                      <div className="deploy-button-container">
                        <Button
                          variant="primary"
                          size="lg"
                          className="unified-deploy-btn"
                          onClick={handleUnifiedDeploy}
                          disabled={!selectedCloudHubAccount || !selectedRepoAccount || !selectedDevOpsAccount || isDeploying}
                        >
                          {isDeploying ? (
                            <>
                              <span className="spinner-border spinner-border-sm mr-2"></span>
                              Deploying...
                            </>
                          ) : (
                            <>🚀 Deploy to All Platforms</>
                          )}
                        </Button>
                      </div>
                    </div>
                  </div>
                )}

                {/* ========================================== */}
                {/* SPRING BOOT DEPLOYMENT TAB */}
                {/* ========================================== */}
                {state.activeTab === 'springDeployment' && state.selectedTech === 'spring' && (
                  <div className="preview-tab-content">
                    {/* Sub-navigation for deployment files */}
                    <div className="spring-deployment-nav">
                      <button
                        className={`deploy-nav-btn ${state.activeDeployTab === 'dockerfile' ? 'active' : ''}`}
                        onClick={() => setState(prev => ({ ...prev, activeDeployTab: 'dockerfile' }))}
                      >
                        🐳 Dockerfile
                      </button>
                      <button
                        className={`deploy-nav-btn ${state.activeDeployTab === 'k8sDeployment' ? 'active' : ''}`}
                        onClick={() => setState(prev => ({ ...prev, activeDeployTab: 'k8sDeployment' }))}
                      >
                        ☸️ K8s Deployment
                      </button>
                      <button
                        className={`deploy-nav-btn ${state.activeDeployTab === 'k8sService' ? 'active' : ''}`}
                        onClick={() => setState(prev => ({ ...prev, activeDeployTab: 'k8sService' }))}
                      >
                        🌐 K8s Service
                      </button>
                      <button
                        className={`deploy-nav-btn ${state.activeDeployTab === 'configuration' ? 'active' : ''}`}
                        onClick={() => setState(prev => ({ ...prev, activeDeployTab: 'configuration' }))}
                      >
                        ⚙️ Deploy Config
                      </button>
                    </div>

                    {/* Show deployment files */}
                    {state.activeDeployTab !== 'configuration' ? (
                      <>
                        <div className="file-header">
                          <span className="file-name">
                            {state.activeDeployTab === 'dockerfile' ? '🐳 Dockerfile' :
                              state.activeDeployTab === 'k8sDeployment' ? '☸️ deployment.yaml' :
                                '🌐 service.yaml'}
                          </span>
                          <button
                            className="copy-btn-small"
                            onClick={() => {
                              const code = state.activeDeployTab === 'dockerfile' ? state.dockerfileData :
                                state.activeDeployTab === 'k8sDeployment' ? state.k8sDeploymentData :
                                  state.k8sServiceData;
                              navigator.clipboard.writeText(code);
                              alert('Copied!');
                            }}
                          >
                            📋
                          </button>
                        </div>
                        <pre className="code-preview">
                          {state.activeDeployTab === 'dockerfile'
                            ? (state.dockerfileData || 'No Dockerfile generated yet')
                            : state.activeDeployTab === 'k8sDeployment'
                              ? (state.k8sDeploymentData || 'No Kubernetes Deployment generated yet')
                              : (state.k8sServiceData || 'No Kubernetes Service generated yet')
                          }
                        </pre>
                      </>
                    ) : (
                      /* Deploy Configuration for Spring Boot */
                      <div className="deployment-config-area">
                        <h4 className="section-title">Configure Spring Boot Deployment</h4>

                        {/* Repository Section */}
                        <div className="deployment-section">
                          <h5 className="subsection-title">📦 Repository Configuration</h5>
                          <div className="deployment-row">
                            <div className="deployment-column">
                              <label className="account-label">Select Platform:</label>
                              <select
                                className="account-dropdown"
                                value={selectedRepoType}
                                onChange={(e) => handleAccountChange('repo-type', e.target.value)}
                              >
                                <option value="">-- Select Repository Platform --</option>
                                <option value="github">🐙 GitHub</option>
                                <option value="gitlab">🦊 GitLab</option>
                                <option value="bitbucket">🪣 Bitbucket</option>
                              </select>
                            </div>

                            {selectedRepoType && (
                              <div className="deployment-column">
                                <label className="account-label">Select Account:</label>
                                <select
                                  className="account-dropdown"
                                  value={selectedRepoAccount}
                                  onChange={(e) => handleAccountChange('repo-account', e.target.value)}
                                >
                                  <option value="">-- Select Account --</option>
                                  {state[selectedRepoType]?.map((account) => {
                                    let displayName = '';
                                    if (selectedRepoType === 'github') {
                                      displayName = account.gitUsername ? `@${account.gitUsername}` : account.username;
                                    } else if (selectedRepoType === 'bitbucket') {
                                      displayName = account.workspace || account.username;
                                    } else if (selectedRepoType === 'gitlab') {
                                      displayName = account.gitUsername || account.username;
                                    }

                                    return (
                                      <option key={account._id || account.id} value={account._id || account.id}>
                                        {displayName}
                                        {account.email && ` • ${account.email}`}
                                      </option>
                                    );
                                  })}
                                  <option value="add_new">+ Add New Account</option>
                                </select>
                                {selectedRepoAccount && selectedRepoAccount !== 'add_new' && (
                                  <div className="account-selected-badge">✓ Repository Configured</div>
                                )}
                              </div>
                            )}
                          </div>
                        </div>

                        {/* DevOps Section */}
                        <div className="deployment-section">
                          <h5 className="subsection-title">🔧 DevOps Platform</h5>
                          <div className="deployment-row">
                            <div className="deployment-column">
                              <label className="account-label">Select Platform:</label>
                              <select
                                className="account-dropdown"
                                value={selectedDevOpsType}
                                onChange={(e) => handleAccountChange('devops-type', e.target.value)}
                              >
                                <option value="">-- Select DevOps Platform --</option>
                                <option value="azaccount">🔷 Azure DevOps</option>
                                <option value="github-actions">🐙 GitHub Actions</option>
                                <option value="gitlab-ci">🦊 GitLab CI/CD</option>
                                <option value="jenkins">⚙️ Jenkins</option>
                              </select>
                            </div>

                            {selectedDevOpsType && (
                              <div className="deployment-column">
                                <label className="account-label">Select Configuration:</label>
                                <select
                                  className="account-dropdown"
                                  value={selectedDevOpsAccount}
                                  onChange={(e) => handleAccountChange('devops-account', e.target.value)}
                                >
                                  <option value="">-- Select Configuration --</option>
                                  {state[selectedDevOpsType]?.map((account) => {
                                    let displayName = '';
                                    if (selectedDevOpsType === 'azaccount') {
                                      const orgMatch = account.organization?.match(/dev\.azure\.com\/(.+)/);
                                      displayName = orgMatch ? orgMatch[1] : account.organization;
                                    } else if (selectedDevOpsType === 'github-actions') {
                                      displayName = account.repository || account.name;
                                    } else if (selectedDevOpsType === 'gitlab-ci') {
                                      displayName = account.project || account.name;
                                    } else if (selectedDevOpsType === 'jenkins') {
                                      displayName = account.server || account.name;
                                    }

                                    return (
                                      <option key={account._id} value={account._id}>
                                        {displayName}
                                      </option>
                                    );
                                  })}
                                  <option value="add_new">+ Add New Configuration</option>
                                </select>
                                {selectedDevOpsAccount && selectedDevOpsAccount !== 'add_new' && (
                                  <div className="account-selected-badge">✓ DevOps Configured</div>
                                )}
                              </div>
                            )}
                          </div>
                        </div>

                        {/* Cloud Platform Section */}
                        <div className="deployment-section">
                          <h5 className="subsection-title">☁️ Cloud Platform</h5>
                          <div className="deployment-row">
                            <div className="deployment-column">
                              <label className="account-label">Select Cloud Provider:</label>
                              <select
                                className="account-dropdown"
                                value={state.selectedCloudProvider || ''}
                                onChange={(e) => setState(prev => ({
                                  ...prev,
                                  selectedCloudProvider: e.target.value,
                                  selectedCloudAccount: ''
                                }))}
                              >
                                <option value="aws">☁️ Amazon Web Services (AWS)</option>
                              </select>
                            </div>

                            {state.selectedCloudProvider && (
                              <div className="deployment-column">
                                <label className="account-label">
                                  Select {state.selectedCloudProvider.toUpperCase()} Account:
                                </label>
                                <select
                                  className="account-dropdown"
                                  value={state.selectedCloudAccount || ''}
                                  onChange={(e) => handleAccountChange('aws-account', e.target.value)}
                                >
                                  <option value="">-- Select Account --</option>
                                  {(state.awsaccount || []).map(account => (
                                    <option key={account._id} value={account._id}>
                                      {account.awsaccesskeyid}
                                    </option>
                                  ))}
                                  <option value="add_new">+ Add New Account</option>
                                </select>

                                {state.selectedCloudAccount && state.selectedCloudAccount !== 'add_new' && (
                                  <div className="account-selected-badge">
                                    ✓ {state.selectedCloudProvider.toUpperCase()} Account Configured
                                  </div>
                                )}
                              </div>
                            )}
                          </div>

                          {/* AWS Deployment Target */}
                          {state.selectedCloudProvider === 'aws' && (
                            <div className="deployment-row" style={{ marginTop: '15px' }}>
                              <div className="deployment-column">
                                <label className="account-label">AWS EKS Cluster:</label>
                                <select
                                  className="account-dropdown"
                                  value={state.awsDeploymentTarget || ''}
                                  onChange={(e) => { const val = e.target.value; setState(prev => ({ ...prev, awsDeploymentTarget: val })); }}
                                >
                                  <option value="">-- Select EKS Cluster --</option>
                                  {(state.awsresources || []).map(resource => (
                                    <option key={resource._id} value={resource._id}>
                                      ☸️ {resource.awscluster} ({resource.location})
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                          )}
                        </div>

                        {/* Deploy Button */}
                        <div className="deploy-button-container">
                          <Button
                            variant="primary"
                            size="lg"
                            className="unified-deploy-btn"
                            onClick={handleSpringBootDeploy}
                            disabled={!selectedRepoAccount || !state.selectedCloudAccount || isDeploying}
                          >
                            {isDeploying ? (
                              <>
                                <span className="spinner-border spinner-border-sm mr-2"></span>
                                Deploying...
                              </>
                            ) : (
                              <>🚀 Deploy Spring Boot Application</>
                            )}
                          </Button>
                        </div>
                      </div>
                    )}
                  </div>
                )}

              </div>
            </div>
          ) : (
            <div className="preview-empty">
              <div className="empty-icon-large">🚀</div>
              {state.loading ? <h2>Generating...</h2> : <h2>Ready to Generate</h2>}
              <p>Enter your prompt in the right panel and click Generate</p>
            </div>
          )}
        </div>

        {/* RIGHT COLUMN - Logs + Prompt */}
        {/* <div className="right-panel-column">
          <div className="console-panel-unified">
            <div className="console-header-simple">
              <div className="console-title-row">
                <span className="console-icon">📊</span>
                <span className="console-title">Console</span>

                {socketConnected && !state.loading && !isDeploying && (
                  <span className="status-badge connected">
                    <span className="status-dot"></span>
                    Connected
                  </span>
                )}

                {(state.loading || isDeploying) && (
                  <span className="status-badge generating">
                    <span className="status-dot"></span>
                    {state.loading ? 'Generating...' : 'Deploying...'}
                  </span>
                )}
              </div>

              {(integrationLogs.length > 0 || deploymentLogs.length > 0) && (
                <button
                  className="clear-btn-header"
                  onClick={() => {
                    setIntegrationLogs([]);
                    setDeploymentLogs([]);
                  }}
                >
                  🗑️ Clear
                </button>
              )}
            </div>

            <div className="console-content-simple">
              <div className="log-stream">
                {[...integrationLogs, ...deploymentLogs]
                  .sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp))
                  .map((log, index) => (
                    <div key={index} className={`log-entry ${log.level || log.type}`}>
                      <span className="log-time">
                        {new Date(log.timestamp).toLocaleTimeString('en-US', {
                          hour: '2-digit',
                          minute: '2-digit',
                          second: '2-digit',
                          hour12: false
                        })}
                      </span>
                      <span className={`log-badge ${log.level || log.type}`}>
                        {(log.level || log.type).toUpperCase()}
                      </span>
                      <span className="log-message">{log.message}</span>
                    </div>
                  ))}

                {integrationLogs.length === 0 && deploymentLogs.length === 0 && (
                  <div className="console-empty">
                    <span className="empty-icon">📋</span>
                    <p>Console logs will appear here</p>
                    <span className="empty-hint">
                      {socketConnected ? 'Ready to generate' : 'Connecting...'}
                    </span>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="prompt-panel-kilo-compact">
            <textarea
              className="prompt-textarea-plain"
              placeholder="Describe changes to your app..."
              value={state.chat}
              onChange={onChange}
            />

            <div className="prompt-actions-bar-compact">
              <button
                className="examples-btn-kilo"
                onClick={() => setShowExamples(true)}
              >
                💡
              </button>

              <div className="prompt-right-actions">
                <span className="char-count-kilo">
                  {state.chat.length} characters
                </span>

                <button
                  className="generate-btn-kilo"
                  onClick={submit}
                  disabled={!state.chat.trim() || state.loading}
                >
                  {state.loading ? (
                    <>
                      <span className="btn-spinner"></span>
                      Generating...
                    </>
                  ) : (
                    <>
                      ✨ Generate
                    </>
                  )}
                </button>
              </div>
            </div>

            {state.loading && (
              <div className="generation-progress-compact">
                <div className="progress-bar-kilo">
                  <div
                    className="progress-fill-kilo"
                    style={{ width: `${state.progress.percent}%` }}
                  ></div>
                </div>
                <div className="progress-info-kilo">
                  <span className="progress-step">{state.progress.step}</span>
                  <span className="progress-percent">{state.progress.percent}%</span>
                </div>
              </div>
            )}
          </div>
        </div> */}
        {/* ✅ RIGHT COLUMN - Replace with ConsolePromptPanel Component */}
        <ConsolePromptPanel
          socketConnected={socketConnected}
          integrationLogs={integrationLogs}
          deploymentLogs={deploymentLogs}
          onClearLogs={() => {
            setIntegrationLogs([]);
            setDeploymentLogs([]);
          }}
          promptValue={state.chat}
          onPromptChange={(value) => setState(prev => ({ ...prev, chat: value }))}

          promptPlaceholder="Describe your integration...

e.g., 'Create a RESTful API with Salesforce connector'"
          onSubmit={submit}
          isLoading={state.loading}
          loadingText="Generating..."
          submitButtonText="Generate"
          progress={state.progress}
          examples={examplePrompts}
          onExampleClick={(example) => setState(prev => ({ ...prev, chat: example.prompt }))}
          showCharCount={true}
          customStatus={isDeploying ? { type: 'deploying', text: 'Deploying...' } : null}
        />




        {/* Examples Modal */}
        {showExamples && (
          <div className="examples-overlay" onClick={() => setShowExamples(false)}>
            <div className="examples-modal-box" onClick={(e) => e.stopPropagation()}>
              <div className="modal-header-box">
                <h3>💡 Example Prompts</h3>
                <button className="close-btn" onClick={() => setShowExamples(false)}>✕</button>
              </div>
              <div className="modal-body-box">
                {examplePrompts.map(example => (
                  <div
                    key={example.id}
                    className="example-card-box"
                    onClick={() => {
                      handlePromptClick(example.prompt);
                      setShowExamples(false);
                    }}
                  >
                    <span className="example-tag">{example.category}</span>
                    <h4 className="example-title-box">{example.title}</h4>
                    <p className="example-text">{example.prompt}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="root">
      <CustomHeaderWithOutAppBar />
      <main className="content">
        {/* <div className="project-overview-wrap"> */}
        {/* <Container className="project-overview-container"> */}
        {/* <Row className="project-container-row"> */}
        {/* <Col xs={12} className="projects-container"> */}
        {getModalBody()}
        {/* </Col> */}
        {/* </Row> */}
        {/* </Container> */}
        {/* </div> */}
      </main>
    </div>
  );
}

export default AIChat;